import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/i18n/I18nContext";
import { LANDING } from "@/constants/testIds";

export default function FAQ() {
  const { t, language } = useI18n();

  const faqs = {
    fr: [
      { q: "Combien de temps faut-il pour créer ma chanson ?", a: "En général quelques minutes seulement, une fois le paiement confirmé. Vous êtes notifié par email et notification dès que c'est prêt." },
      { q: "Puis-je utiliser mes propres paroles ?", a: "Oui, vous pouvez soit laisser notre IA écrire les paroles automatiquement, soit fournir vos propres paroles personnalisées." },
      { q: "Est-ce que je peux me faire rembourser ?", a: "Si une erreur technique empêche la création de votre chanson après plusieurs tentatives, vous êtes remboursé intégralement. Contactez notre support depuis votre espace client." },
      { q: "Comment fonctionne le paiement ?", a: "Sur le site comme sur l'application Android, tout s'exprime en jetons : vous achetez un pack de jetons (5, 10, 20, 50, 100 ou 200) puis vous les utilisez pour créer vos chansons. Sur Android, l'achat passe par Google Play ; sur le web, par notre paiement sécurisé." },
      { q: "Puis-je offrir la chanson à quelqu'un directement ?", a: "Oui, activez l'option 'Envoi cadeau' pour programmer l'envoi automatique à la date de votre choix, avec un message personnalisé." },
    ],
    en: [
      { q: "How long does it take to create my song?", a: "Usually just a few minutes once payment is confirmed. You'll be notified by email and push notification as soon as it's ready." },
      { q: "Can I use my own lyrics?", a: "Yes, you can either let our AI write the lyrics automatically, or provide your own custom lyrics." },
      { q: "Can I get a refund?", a: "If a technical error prevents your song from being created after several attempts, you'll be fully refunded. Contact our support from your account." },
      { q: "How does payment work?", a: "On the website and the Android app alike, everything is expressed in tokens: you buy a token pack (5, 10, 20, 50, 100 or 200) and use them to create your songs. On Android the purchase goes through Google Play; on the web, through our secure payment." },
      { q: "Can I gift the song directly to someone?", a: "Yes, enable the 'Gift sending' option to schedule automatic delivery on your chosen date, with a personalized message." },
    ],
  };

  const list = faqs[language] || faqs.fr;

  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-center font-heading text-2xl font-medium tracking-tight sm:text-3xl lg:text-4xl">
          {t("landing.faqTitle")}
        </h2>
        <Accordion type="single" collapsible className="mt-10">
          {list.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={LANDING.faqItem(i)}>
              <AccordionTrigger className="text-left font-heading text-base">{item.q}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
